import React, { useState, useRef, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import ReactFlowPannel from '../../react-flow/ReactFlowPannel'
import WorkflowNavigateSection from './WorkflowDataProcessorNavigateSection'
import convertToRequiredFormat from '../../react-flow/JsonConverter'
import { DataProcessorApi } from '../../../services/DataProcessorApi'
import { useAxios } from '../../../contexts/AxiosProvider'
import LoadingIcon from '../../../reusable-component/LoadingIcon'
import { getEnvironmentConfig } from '../../../constants/CloudConstant'

const DataProcessor = ({ userData, workflow, engagementId, processType }) => {
    const location = useLocation();
    const axios = useAxios();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [dataProcessorRefreshStatus, setDataProcessorRefreshStatus] = useState({
        workflow_id: workflow.workflow_id,
        workflow_type: "DATA-PROCESSOR",
        status: '',
        runDisabled: false,
        saveDisabled: false,
        cloudEnvironment: getEnvironmentConfig().cloudEnvironment
    })

    const refSubmitDataProcessor = useRef(null)
    const callDataProcessorFn = () => {
        if (refSubmitDataProcessor?.current) {
            const getNodeData = JSON.parse(sessionStorage.getItem('saved_node')) || [];
            const getElementCount = parseInt(sessionStorage.getItem('elementCount') || 0, 10);
            const updateNodes = JSON.parse(sessionStorage.getItem('updatedNodes')) || [];

            if (!getNodeData) {
                enqueueSnackbar('Please enter and submit some data for the dragged steps!!', {
                    variant: 'error',
                    autoHideDuration: 3000,
                    anchorOrigin: { vertical: 'top', horizontal: 'right' },
                })
            } else if (getNodeData.length !== getElementCount) {
                enqueueSnackbar('All nodes are not submitted. Please submit all nodes! ', {
                    variant: 'error',
                    autoHideDuration: 3000,
                    anchorOrigin: { vertical: 'top', horizontal: 'right' },
                });
            } else if (updateNodes.length !== 0) {
                enqueueSnackbar('Schema has been updated please validate the schema!', {
                    variant: 'error',
                    autoHideDuration: 3000,
                    anchorOrigin: { vertical: 'top', horizontal: 'right' },
                });
            } else {
                refSubmitDataProcessor.current();
                navigate(`/dep/workflow/${engagementId}/${processType}`, {
                    state: {
                        ...userData
                    }
                });
            }
        }
    };

    const refreshDataProcessorStatus = async (workflow_id) => {

        try {
            setLoading(true)

            const response = await DataProcessorApi.refreshDataProcessorStatus(axios, workflow_id)
            if (response.status === 200) {
                setDataProcessorRefreshStatus(response.data)
            }

        } catch (error) {
            enqueueSnackbar(`Something went wrong`, {
                variant: 'error',
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'top', horizontal: 'right' },
            });
        } finally {
            setLoading(false)
        }
    }


    useEffect(() => {
        refreshDataProcessorStatus(workflow.workflow_id)
    }, [])

    return (
        <>
            <div style={{ position: 'relative', height: 'calc(100vh - 250px)', overflow: 'auto', display: 'flex', flexDirection: 'column', marginTop: 2 }}>
                <div style={{ height: '85%' }}>
                    <ReactFlowPannel ref={refSubmitDataProcessor} setLoading={setLoading} userData={userData} processType={processType} workflow={workflow} />
                </div>
                <div style={{ height: '10%' }}>
                    <WorkflowNavigateSection
                        value={2}
                        userData={userData}
                        workflow={workflow}
                        handleChangeIndex={2}
                        callDataProcessorFn={callDataProcessorFn}
                        dataProcessorRefreshStatus={dataProcessorRefreshStatus}
                        loading={loading} />
                </div>
                {loading && <LoadingIcon />}
            </div>
        </>
    )
}

export default DataProcessor